import React, { type ComponentProps } from 'react';
import { Platform } from 'react-native';

import { OrganizationLinksFooter } from '../OrganizationLinksFooter';

// This footer component is only present on web, not on native.
export const AppFooter = (props: Props) => {
  const { style, isLandmark } = props;

  if (Platform.OS !== 'web') return null;

  return <OrganizationLinksFooter style={style} isLandmark={isLandmark} />;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = ComponentProps<typeof OrganizationLinksFooter>;
